import React from "react";

import { Trans } from "app/utils";
import { Icon } from "@culturehq/components";

const SelectedStories = ({ selectedStories }) => {
  const getUsersArray = () => {
    const users = selectedStories.map(story => story.creator.id);
    return [...new Set(users)];
  };

  const getStoryPromptsArray = () => {
    const storyPrompts = selectedStories.map(story => story.question.id);
    return [...new Set(storyPrompts)];
  };

  const getStoryPromptTagsArray = () => {
    let tags = [];
    selectedStories.forEach(story => {
      tags = [...tags, ...story.question.storyQuestionTags.map(tag => tag.entity.id)];
    });
    return [...new Set(tags)];
  };
  const users = getUsersArray();
  const storyPrompts = getStoryPromptsArray();
  const storyPromptTags = getStoryPromptTagsArray();

  return (
    <div className="ApproveStoryModal__SelectedStories">
      <div className="Approve-Button--icon__container">
        <Icon className="Approve-Button--icon" icon="tale" />
      </div>
      <span className="ApproveStoryModal__SelectedStories__description">
        <strong>{selectedStories.length} Stor{selectedStories.length > 1 ? "ies" : "y"}</strong>
        {" "}
        <Trans>selected from</Trans>
        {" "}
        <strong>{users.length} user{users.length > 1 ? "s" : ""}</strong>
        {" "}
        <Trans>across</Trans>
        {" "}
        <strong>{storyPrompts.length} prompt{storyPrompts.length > 1 ? "s" : ""}</strong>
        {" "}
        <Trans>and</Trans>
        {" "}
        <strong>{storyPromptTags.length} tag{storyPromptTags.length > 1 ? "s" : ""}</strong>
      </span>
    </div>
  );
};

export default SelectedStories;
